import { render } from "./IconClose.vue?vue&type=template&id=f1fe9df2"
const script = {}

import "./IconClose.vue?vue&type=style&index=0&id=f1fe9df2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__